import { render, staticRenderFns } from "./SiteIntro.vue?vue&type=template&id=9d8f50a6&scoped=true&"
import script from "./SiteIntro.vue?vue&type=script&lang=js&"
export * from "./SiteIntro.vue?vue&type=script&lang=js&"
import style0 from "./SiteIntro.vue?vue&type=style&index=0&id=9d8f50a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8f50a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
